import axios from 'axios'

import { normalizeError } from './utils'

const statusService = () => {
  const fetchStatuses = async (accessToken) => {
    try {
      const config = { headers: { Authorization: `Bearer ${accessToken}` } }
      const response = await axios.get('/api/status/servers', config)
      return response.data
    } catch (error) {
      throw normalizeError(error)
    }
  }

  return { fetchStatuses }
}

export default statusService()
